import { el } from 'redom';

import OutsideClickEventRegistration from 'lib/outside-click-event-registration';

import TextArea from 'generics/components/text-input/textarea';

import {
  displayElementAroundAnchor
} from 'utilities/element-position';

class PathInputPanel {

  constructor(configuration) {

    this.anchor = configuration.anchor;
    this.onClose = configuration.onClose;
    this.onChange = configuration.onChange;

    this.input = new TextArea({
      value: configuration.value || '',
      onEnterKey: this.handlePathChange.bind(this),
      placeholder: 'M 100 10 L 40 180 L 190 60 L 10 60 L 160 180 Z',
      onEscapeKey: this.onClose
    });

    this.el = el('#path-input-panel-main', [
      this.input
    ]);

  }

  handlePathChange(path) {

    this.onChange(path);
    this.onClose();

  }

  position() {

    const element = this.el;
    const anchorElement = this.anchor;
    const viewportElement = void 0;
    const verticalOffset = 0;
    const horizontalOffset = 0;
    const startSide = 'top';
    const placeOnCenter = true;
    const positionableSides = void 0;

    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);
    displayElementAroundAnchor(element, anchorElement, viewportElement, verticalOffset, horizontalOffset, startSide, placeOnCenter, positionableSides);

  }

  onmount() {

    this.outsideEventRegistration = new OutsideClickEventRegistration(this.el, this.onClose);

    this.position();

    this.input.focus();

  }

  onunmount() {

    this.outsideEventRegistration.cancel();

  }

}

export default PathInputPanel;